/** @jsx jsx */
const { Component, Fragment } = wp.element;
import { css, jsx } from '@emotion/react';
import ReactBorderColorPicker from './react-border-color-picker';
import { setStyle } from '../utility';
import { v4 as uuidv4 } from 'uuid';
const colorParse = require( 'color-parse' );
const { TextControl, Button, ButtonGroup, SelectControl } = wp.components;
import classNames from 'classnames';
import { AlphaPicker } from 'react-color';
const { __ } = wp.i18n;
const merge = require( 'deepmerge' );
const equal = require( 'fast-deep-equal' );

export class BorderInputControl extends Component {
	constructor( props ) {
		super( props );

		this.state = {
			top: { width: '', color: '', style: '' },
			right: { width: '', color: '', style: '' },
			bottom: { width: '', color: '', style: '' },
			left: { width: '', color: '', style: '' },
			mode: '1', // 1 | 4 number of inputs shown
			styleTypes: [
				{ label: 'Solid', value: 'solid' },
				{ label: 'Dotted', value: 'dotted' },
				{ label: 'Dashed', value: 'dashed' },
				{ label: 'Double', value: 'double' },
				{ label: 'Groove', value: 'groove' },
				{ label: 'Ridge', value: 'ridge' },
				{ label: 'Inset', value: 'inset' },
				{ label: 'Outset', value: 'outset' },
				{ label: 'None', value: 'none' },
				{ label: 'Hidden', value: 'hidden' },
			],
		};

		this.updateWidthInput = this.updateWidthInput.bind( this );
		this.updateStyleInput = this.updateStyleInput.bind( this );
		this.updateMode = this.updateMode.bind( this );
		this.updateEmptyValues = this.updateEmptyValues.bind( this );
		this.updateColorProp = this.updateColorProp.bind( this );
	}

	static getDerivedStateFromProps( props, state ) {
		const { attribute } = props;

		// console.log(
		//   "%c getDerivedStateFromProps: ",
		//   "background: #222; color: pink",
		//   attribute
		// );
		//console.log("ATTR", attribute);

		// calculated state from props
		let cs = {}; // initialize to empty object (e.g. if JSON attribute is empty)

		// if attribute not an empty string then initialize cs with full data
		if ( attribute !== '' ) {
			const parseAttr = JSON.parse( attribute );

			// if simplified border string
			if ( parseAttr.hasOwnProperty( 'literal' ) ) {
				// is their a 'literal' prop?
				const literalCSS = parseAttr.literal;
				const literalCSSArr = literalCSS.split( ' ' );
				//console.log("literalCSSArr", literalCSSArr);

				cs = { ...state };

				literalCSSArr.forEach( ( el ) => {
					cs.top.width = literalCSSArr[ 0 ]; // assuming 1st index is the border width
					cs.right.width = literalCSSArr[ 0 ];
					cs.bottom.width = literalCSSArr[ 0 ];
					cs.left.width = literalCSSArr[ 0 ];

					cs.top.color = literalCSSArr[ 1 ]; // assuming 2nd index is the border color
					cs.right.color = literalCSSArr[ 1 ];
					cs.bottom.color = literalCSSArr[ 1 ];
					cs.left.color = literalCSSArr[ 1 ];

					cs.top.style = literalCSSArr[ 2 ]; // assuming 3rd index is the border style
					cs.right.style = literalCSSArr[ 2 ];
					cs.bottom.style = literalCSSArr[ 2 ];
					cs.left.style = literalCSSArr[ 2 ];
				} );
			}

			// if full border object
			if (
				parseAttr.hasOwnProperty( 'top' ) &&
				parseAttr.hasOwnProperty( 'right' ) &&
				parseAttr.hasOwnProperty( 'bottom' ) &&
				parseAttr.hasOwnProperty( 'left' )
			) {
				cs = { ...parseAttr };
			}
		}

		// expect CSS value to be empty, or 4 border values
		if ( ! equal( cs, state ) ) {
			//console.log('NOT EQUAL: UPDATING...', cs, state);
			return cs;
		}
		//console.log('EQUAL: DO NOTHING', cs, state);
		return null;
	}

	componentDidMount() {
		//console.log('componentDidMount: <BorderInputControl />');
		//console.log('STATE: ', this.state);
	}

	componentDidUpdate( prevProps, prevState ) {
		//console.log('componentDidUpdate: <BorderInputControl />');
	}

	updateColorProp( newCol, location ) {
		const { update } = this.props;
		const { mode } = this.state;

		//console.log('%c updateColorProp: ', 'background: #222; color: pink', newCol);
		//console.log('################ updateColorProp', tmpObj, location);
		//setStyle(location, colStr, this.props);

		const newState = { ...this.state };
		if ( mode === '1' ) {
			newState.top.color = newCol;
			newState.right.color = newCol;
			newState.bottom.color = newCol;
			newState.left.color = newCol;
		} else if ( mode === '4' ) {
			newState[ location ].color = newCol;
		}

		//console.log('BEFORE PATCH: ', newState, location);

		// patch empty input values
		this.updateEmptyValues( newState );

		//console.log('AFTER PATCH: ', newState, location);

		this.setState( newState, () => {
			//console.log('STATE UPDATED', this.state);

			const { update } = this.props;

			//let tmpObj = {};
			//tmpObj[update] = JSON.stringify(newState);
			//setAttributes(tmpObj);
			//console.log('Setting input attr.', JSON.stringify(newState));
			setStyle( update, JSON.stringify( newState ), this.props );
		} );
	}

	updateStyleInput( newVal, location ) {
		const { update } = this.props;
		const { mode } = this.state;

		//console.log('%c updateStyleInput: ', 'background: #222; color: pink', newVal);

		const newState = { ...this.state };
		if ( mode === '1' ) {
			newState.top.style = newVal;
			newState.right.style = newVal;
			newState.bottom.style = newVal;
			newState.left.style = newVal;
		} else if ( mode === '4' ) {
			newState[ location ].style = newVal;
		}

		//console.log('BEFORE PATCH: ', newState, location);

		// patch empty input values
		this.updateEmptyValues( newState );

		//console.log('AFTER PATCH: ', newState, location);

		this.setState( newState, () => {
			//console.log('STATE UPDATED', this.state);

			const { update } = this.props;

			//let tmpObj = {};
			//tmpObj[update] = JSON.stringify(newState);
			//setAttributes(tmpObj);
			//console.log('Setting input attr.', JSON.stringify(newState));
			setStyle( update, JSON.stringify( newState ), this.props );
		} );
	}

	updateWidthInput( newVal, location ) {
		const { update } = this.props;
		const { mode } = this.state;

		// @TODO Is this needed?
		// don't allow empty values that could break styles
		let newValue = newVal.target.value;
		if ( newValue === '' ) {
			newValue = '0';
		}

		const newState = { ...this.state };
		if ( mode === '1' ) {
			newState.top.width = newValue;
			newState.right.width = newValue;
			newState.bottom.width = newValue;
			newState.left.width = newValue;
		} else if ( mode === '4' ) {
			newState[ location ].width = newValue;
		}

		//console.log('BEFORE PATCH: ', newState, location);

		// patch empty input values
		this.updateEmptyValues( newState );

		//console.log('AFTER PATCH: ', newState, location);

		this.setState( newState, () => {
			//console.log('STATE UPDATED', this.state);

			const { update } = this.props;

			//let tmpObj = {};
			//tmpObj[update] = JSON.stringify(newState);
			//setAttributes(tmpObj);
			//console.log('Setting input attr.', JSON.stringify(newState));
			setStyle( update, JSON.stringify( newState ), this.props );
		} );
	}

	updateMode( newMode ) {
		const { mode, top, right, bottom, left } = this.state;
		const newState = { ...this.state };

		//console.log('1. PRE:', newState, newMode, mode);

		newState.mode = newMode;
		if ( newMode === '1' ) {
			//console.log('<<<<<<<<<< MODE #1:', newState);
			newState.right = top;
			newState.bottom = top;
			newState.left = top;
		}

		// @TODO update to patch all empty values
		// patch empty input values with "0"
		this.updateEmptyValues( newState );

		//console.log('2. PRE:', newState);

		this.setState( newState, () => {
			const { update } = this.props;

			//let tmpObj = {};
			//tmpObj[update] = JSON.stringify(newState);
			//setAttributes(tmpObj);
			//console.log('Setting Mode', JSON.stringify(newState));
			setStyle( update, JSON.stringify( newState ), this.props );
		} );
	}

	// @TODO update
	updateEmptyValues( state ) {
		//console.log("STATE BEFORE: ", state);

		// initialize other input values if empty
		for ( const [ key, value ] of Object.entries( state ) ) {
			//console.log("?????????????????? DATA", key, value);
			// only inspect other state values if 'top', 'right', 'bottom', 'left'
			if (
				key === 'top' ||
				key === 'right' ||
				key === 'bottom' ||
				key === 'left'
			) {
				//console.log("ATTEMPTING TO UPDATE", key, value);

				if ( value.width === '' ) {
					state[ key ].width = '0';
				}

				if ( value.color === '' ) {
					state[ key ].color = '#ddd';
				}

				if ( value.style === '' ) {
					state[ key ].style = 'solid';
				}
				//console.log('<< KEY:', key, location);
			}
		}

		//console.log("STATE AFTER: ", state);
	}

	render() {
		const {
			update,
			attribute,
			labels,
			setAttributes,
			title,
			hideMode,
		} = this.props;
		const { top, right, bottom, left, mode } = this.state;

		const hideModeValue = hideMode ? 'visibility: hidden;' : '';
		//console.log("hideMode", hideMode, hideModeValue);

		const componentStyles = css`
			width: 100%;

			.br-title-wrapper {
				margin: 0 0 12px 0;
				display: flex;
				align-items: center;
				justify-content: space-between;

				h2 {
					margin: 0;
				}

				.components-button.is-small {
					height: 18px;
					line-height: 19px;
					padding: 0px 6px;
					font-size: 10px;
					width: 18px;
				}
			}

			.br-wrapper .width-wrapper {
				display: flex;
				align-items: center;
				margin-bottom: 5px;
				text-align: center;
				position: relative;
				/*justify-content: flex-end;*/

				.components-base-control__field {
					margin-bottom: 0;
				}
			}

			/* .br-wrapper .components-base-control {
        width: 50px;
        margin-right: 7px;
      } */

			.br-wrapper input.components-text-control__input {
				font-size: 12px;
			}

			.br-wrapper .components-base-control__label {
				text-align: center;
				font-size: 12px;
				max-width: initial;
				margin: 0;
			}

			/* .br-wrapper .components-base-control__field {
				width: 50px;
        margin-right: 7px;
        margin-bottom: 8px;
      } */

			.br-wrapper .components-base-control {
				margin-right: 7px;
				margin-bottom: 8px;
			}

			.br-wrapper .components-base-control.faqstyle {
				width: 85px;
			}
			.br-wrapper .components-base-control.color {
				width: 50px;
			}

			.br-wrapper .components-base-control.width > div {
				display: flex;
				align-items: center;
			}
			.br-wrapper
				.components-base-control.width
				.components-text-control__input {
				width: 50px;
			}
			.br-wrapper
				.components-base-control.width
				.components-base-control__label {
				margin-right: 10px;
				width: 40px;
				text-align: left;
				font-size: 1em;
			}

			.br-wrapper .components-base-control__help {
				font-size: 10px;
				text-align: center;
			}

			& > h2 {
				margin-bottom: 15px;
			}

			.description {
				font-size: 12px;
			}

			.btn-groups-wrapper {
				${ hideModeValue }
				opacity: 0;
				transition: opacity 0.2s ease-in-out;

				.components-button-group .components-button {
					border-radius: 0;
					display: inline-flex;
					color: #888;
					box-shadow: inset 0 0 0 1px #555;
				}

				.components-button:focus:not( :disabled ) {
					box-shadow: 0 0 0 1.5px #555;
				}

				.components-button.is-pressed {
					color: #fff;
					background: #555;
				}
			}

			&:hover .btn-groups-wrapper {
				opacity: 1;
			}
		`;

		const inputID = uuidv4();

		/*
		// <BorderControlsRow val={top} location="top" label="Top" />

		const BorderControlsRow = (props) => {

			const { location, label, val} = props;
			const id = `br-${location}-l-${inputID}`;

			return (
				<div className="width-wrapper">
					<div className="components-base-control width">
						<div className="components-base-control__field">
							{mode === '4' &&
								<label className="components-base-control__label" htmlFor={id}>{label}</label>
							}
							<input className="components-text-control__input" type="number" id={id} autoComplete="off" min="0" max="200" value={val.width} onChange={(value) => {console.log('TEST', value);this.updateWidthInput(value, location)}} />
						</div>
					</div>
					<ReactBorderColorPicker location={location} color={val.color} setAttributes={setAttributes} updateColorProp={this.updateColorProp} />
					<SelectControl
						className="faqstyle"
						value={val.style}
						options={this.state.styleTypes}
						onChange={(value) => this.updateStyleInput(value, location)}
					/>
				</div>
			)
		};
		*/

		return (
			<div css={ componentStyles }>
				<div className="br-title-wrapper">
					<h2>{ title } (px)</h2>
					<div className="btn-groups-wrapper">
						<ButtonGroup
							className="mode-btn-group"
							title="input mode"
						>
							<Button
								isPressed={ mode === '1' }
								onClick={ () => this.updateMode( '1' ) }
								isSmall
							>
								1
							</Button>
							<Button
								isPressed={ mode === '4' }
								onClick={ () => this.updateMode( '4' ) }
								isSmall
							>
								4
							</Button>
						</ButtonGroup>
					</div>
				</div>
				<div className="br-wrapper">
					{ ( mode === '1' || mode === '4' ) && (
						<div className="width-wrapper">
							<div className="components-base-control width">
								<div className="components-base-control__field">
									{ mode === '4' && (
										<label
											className="components-base-control__label"
											htmlFor={ `br-top-l-${ inputID }` }
										>
											Top
										</label>
									) }
									<input
										className="components-text-control__input"
										type="number"
										id={ `br-top-l-${ inputID }` }
										autoComplete="off"
										min="0"
										max="200"
										value={ top.width }
										onChange={ ( val ) =>
											this.updateWidthInput( val, 'top' )
										}
									/>
								</div>
							</div>
							<ReactBorderColorPicker
								location="top"
								color={ top.color }
								setAttributes={ setAttributes }
								updateColorProp={ this.updateColorProp }
							/>
							<SelectControl
								className="faqstyle"
								value={ top.style }
								options={ this.state.styleTypes }
								onChange={ ( val ) =>
									this.updateStyleInput( val, 'top' )
								}
							/>
						</div>
					) }
					{ mode === '4' && (
						<div className="width-wrapper">
							<div className="components-base-control width">
								<div className="components-base-control__field">
									<label
										className="components-base-control__label"
										htmlFor={ `br-top-r-${ inputID }` }
									>
										Right
									</label>
									<input
										className="components-text-control__input"
										type="number"
										id={ `br-top-r-${ inputID }` }
										autoComplete="off"
										min="0"
										max="200"
										value={ right.width }
										onChange={ ( val ) =>
											this.updateWidthInput(
												val,
												'right'
											)
										}
									/>
								</div>
							</div>
							<ReactBorderColorPicker
								location="right"
								color={ right.color }
								setAttributes={ setAttributes }
								updateColorProp={ this.updateColorProp }
							/>
							<SelectControl
								className="faqstyle"
								value={ right.style }
								options={ this.state.styleTypes }
								onChange={ ( val ) =>
									this.updateStyleInput( val, 'right' )
								}
							/>
						</div>
					) }
					{ mode === '4' && (
						<div className="width-wrapper">
							<div className="components-base-control width">
								<div className="components-base-control__field">
									<label
										className="components-base-control__label"
										htmlFor={ `br-bottom-r-${ inputID }` }
									>
										Bottom
									</label>
									<input
										className="components-text-control__input"
										type="number"
										id={ `br-bottom-r-${ inputID }` }
										autoComplete="off"
										min="0"
										max="200"
										value={ bottom.width }
										onChange={ ( val ) =>
											this.updateWidthInput(
												val,
												'bottom'
											)
										}
									/>
								</div>
							</div>
							<ReactBorderColorPicker
								location="bottom"
								color={ bottom.color }
								setAttributes={ setAttributes }
								updateColorProp={ this.updateColorProp }
							/>
							<SelectControl
								className="faqstyle"
								value={ bottom.style }
								options={ this.state.styleTypes }
								onChange={ ( val ) =>
									this.updateStyleInput( val, 'bottom' )
								}
							/>
						</div>
					) }
					{ mode === '4' && (
						<div className="width-wrapper">
							<div className="components-base-control width">
								<div className="components-base-control__field">
									<label
										className="components-base-control__label"
										htmlFor={ `br-bottom-l-${ inputID }` }
									>
										Left
									</label>
									<input
										className="components-text-control__input"
										type="number"
										id={ `br-bottom-l-${ inputID }` }
										autoComplete="off"
										min="0"
										max="200"
										value={ left.width }
										onChange={ ( val ) =>
											this.updateWidthInput( val, 'left' )
										}
									/>
								</div>
							</div>
							<ReactBorderColorPicker
								location="left"
								color={ left.color }
								setAttributes={ setAttributes }
								updateColorProp={ this.updateColorProp }
							/>
							<SelectControl
								className="faqstyle"
								value={ left.style }
								options={ this.state.styleTypes }
								onChange={ ( val ) =>
									this.updateStyleInput( val, 'left' )
								}
							/>
						</div>
					) }
				</div>
			</div>
		);
	}
}
